import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'

export default class extends Resource {
  static name = 'account_webhook'

  static get fields () {
    return {
      id: new UUID(),
      event: new STRING(),
      endpoint: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      account: new ITEM(Account)
    }
  }
}
